import React, { useState, useEffect } from 'react';
import './RatingsOverviewModal.css';
import { RatingStrawberries } from '../RatingStrawberries';
import { Spinner } from '../Spinner/Spinner';
import UserAvatar from '../UserAvatar/UserAvatar';

export default function RatingsOverviewModal({ show, ratings, onClose, isLoading }) {
  const [sortBy, setSortBy] = useState('rating');
  const [sortedRatings, setSortedRatings] = useState([]);
  const [mounted, setMounted] = useState(false);

  useEffect(() => {
    setMounted(true);
    return () => setMounted(false);
  }, []);

  useEffect(() => {
    if (!ratings || !Array.isArray(ratings)) return;
    
    const sorted = [...ratings].sort((a, b) => {
      if (sortBy === 'rating') {
        return b.rating - a.rating;
      } else {
        return (a.userName || '').localeCompare(b.userName || '');
      }
    });
    
    setSortedRatings(sorted);
  }, [ratings, sortBy]);

  return (
    <div className={`modal-overlay ${mounted ? 'mounted' : ''}`} onClick={onClose}>
      <div className="ratings-modal" onClick={e => e.stopPropagation()}>
        <div className="ratings-modal-header">
          <h3>{show.title}</h3>
          <button className="close-button" onClick={onClose}>
            <i className="fas fa-times"></i>
          </button>
        </div>

        <div className="sort-pills">
          <button 
            className={`sort-pill ${sortBy === 'name' ? 'active' : ''}`}
            onClick={() => setSortBy('name')}
          >
            Namn
          </button>
          <button 
            className={`sort-pill ${sortBy === 'rating' ? 'active' : ''}`}
            onClick={() => setSortBy('rating')}
          >
            Flest smultron
          </button>
        </div>

        <div className="ratings-list">
          {isLoading ? (
            <div className="loading-container">
              <Spinner size="small" />
            </div>
          ) : sortedRatings.length > 0 ? (
            sortedRatings.map((rating, index) => (
              <div key={index} className="rating-item">
                <div className="user-info">
                  <UserAvatar 
                    user={{
                      displayName: rating.userName,
                      photoURL: rating.userPhoto
                    }} 
                    size="small" 
                  />
                  <span className="user-name">{rating.userName}</span>
                </div>
                <RatingStrawberries 
                  rating={rating.rating} 
                  readonly={true}
                  showRatingCount={false}
                  disableHover={true}
                  showDecimals={false}
                  small={true}
                />
              </div>
            ))
          ) : (
            <div className="no-ratings">
              Inga betyg än
            </div>
          )}
        </div>
      </div>
    </div>
  );
} 